export const environment = {
    production: true,
    app: 'innovateBackendApp-Staging',
    innovate: {
        //  url: 'http://god09622:3001',
        url: 'https://stgedgeapi.innovatesample.com',
        maskedUrl: 'https://survey-stage.answerplatform.com',
        FEMaskedURL: 'https://surveys-stage.answerplatform.com',
        newBEHost: 'https://stagesurveyflow-api.answerplatform.com',
        version: 'v1',
        surveyClosedMessages: {
            0: { 'h1': 'Survey Unavailable', 'h4': 'Sorry, this survey is currently not available.' }, //normal
            1: { 'h1': 'Thank you for trying this survey.', 'h4': 'We’re sorry, but you were not able to complete that survey. Sometimes the survey is looking for a particular demographic or specific types of interests, and you may not have fit what they were looking for..' }, // disqualify
            2: { 'h1': 'Survey Unavailable', 'h4': 'Sorry, this survey already taken by you.' },
            3: { 'h1': 'Survey Unavailable', 'h4': 'mis match of query string data from saved data.' },
            4: { 'h1': 'Survey Unavailable', 'h4': 'Sorry, transaction id not exist in query string.' },
            5: { 'h1': 'Thank you for trying this survey.', 'h4': 'We’re sorry, but you were not able to complete that survey. When a survey has filled in the number of respondents who fit the goal, it will be closed' } // quota full
        },
        zipcodesQuesId: 3,
        masterZipAnsKeyObj: {
            DMA_CODE: 'dma',
            DMA_NAME: 'dmaName',
            REGION: 'rgn',
            STATE: 'stName',
            ZIPCODES: 'id'
        },
        // recaptchaSiteKey: "6Lczi6cUAAAAAOyU5318imzkIGJPZQtX9htdtp9J",
        inboxSupId: 94,
        pointClubSupId: '32',
        BIHSupId: '5121',
        numZipCodeSupportedCnt: {//support Numeric Zipcode only
            0: "US",
            1: "IN"
        },
        cntShortCode: {
            "US": "United States"
            //"GB": "United Kingdom",
            //"CA": "Canada"
        },
        zipCntShortCode: { // ADMIN-5113
            "GB": "United Kingdom",
            "CA": "Canada"
        },
        recaptchaDisabledOnGrpId: [15051, 15052],
        // enableRecaptcha: true, // false means recaptcha is disabled
        enableOEVaildation: true,        // false means it will check for oe validation
        piiOptQuesId: 8458,
        piiCategoryId: 207,
        smsCategoryId: 232,
        questionType: {
            'numericOpenEnded': 'Numeric Open Ended',
            'openEndedText': 'Open End-Text'
        },
        redHerringQuestionId: 4,
        dobRedHerringQId: 8608,
        dobRedHerringQueskey: "DOB",
        "qualitativeQuesCatId": 208,
        dynamicProGPTCatId: 244,
        transactionStatus: {
            "OQ": 3,
            "QT": 4,
            "PST": 5,
            "SSDNC": 6,
            "PSOQ": 7,
            "PSQT": 8,
        },
        geoQuestionKeys: ["DMA_NAME", "REGION", "STATE", "ZIPCODES"],
        trimsterQuestionsAdded: ['PARENTING_12859', 'PARENTING_12860'],
        trimsterQueKey: "PARENTING_12859",
        babyCenterQueCatId: 214,
        babyCenterProfileSurveyJobId: 5571421,
        wteProfileSurveyJobId: 5654229,
        bbCenterExpectedDueDateQueId: 12792,
        bbCenterChildInfoQueId: 12796,
        skipQuestionsOn: {
            'BABY_CENTER_12785': { skipOnValue: 'yes', skipKeys: ['BABY_CENTER_12786', 'BABY_CENTER_12793'] },
            'BABY_CENTER_12786': { skipOnValue: 'yes', skipKeys: ['BABY_CENTER_12793', 'BABY_CENTER_12792'] },
            'BABY_CENTER_12793': { skipKeys: ['BABY_CENTER_12792'] },
            'BABY_CENTER_12795': { skipOnValue: '0', skipKeys: ['BABY_CENTER_12796', 'BABY_CENTER_12797'], addChildInfo: true }
        },
        profilingJobs: [78495],
        DISABLE_FINGERPRINTING: false,
        trimsterWeeks: [
            { "min": 0, "max": 13, "trimster": 1, "week": 1 },
            { "min": 13.01, "max": 26, "trimster": 2, "week": 1 },
            { "min": 26.01, "max": 40, "trimster": 3, "week": 1 },
            { "min": 41.01, "trimster": 4, "week": 2 }
        ],
        babyCenterChildQueAdded: ['BABY_CENTER_12795', 'BABY_CENTER_12796'],
        ageOfChildrenQueId: 6796,
        babyCenterChildCountQueId: 12795,
        ageOfChildrenQueKey: "DEMOGRAPHIC_6796",
        teenAge: 13,
        babyCenterChildCountQueKey: "BABY_CENTER_12795",
        smsVerificationRetries: 3,
        triggerNewSupplierURL : true,
        researchDefender:{
            getTokenAPI : 'https://staging.rtymgt.com/api/v3/respondents/get_token/93f02271-e4df-4a31-8af8-5def143e626e?tokens=1',
            activityURL : 'https://stage.resdefio.com/activity?range=24&panel_id=',
            headerValue: 'jVpyBj0bSE4m6frDqRGi85UIwwZ958BX5HrUTeu5',
            xhrFields: {
              'Access-Control-Allow-Methods' : 'GET, POST',
              'Access-Control-Allow-Headers' : "Access-Control-Allow-Headers, Origin, X-Requested-With, Content-Type, Accept, Authorization",
              'Access-Control-Allow-Credentials' : true,
            },
            activityTimeout: 8000,
            getTokenTimeout: 8000,
        },
        IPQS_URL: 'https://www.ipqscloud.com/api/stagesurveyflow.pointclub.com/EaNdojhqqL2ByU9s9sIPB5GokoJCqyw2VbGCMFNGzdsGYzuYe4pTEfEsIDKzRr3dk7fZoGjsrNon9QjIE3KTif5rqpkNexeXylZWVSyqO6INYTzodtuGaW9njw4TPGusYjdIEAapl9jqgUr8OqkrXUuk1PdnxMQTheZG3qre3H6bX3XawdGOSAGbiPEqAFFmNFPCw0sLvZKv6vM1wjRsf4qHwsYvDrGDW8EiPs7khGykphuIhujPi3KqIn47qDj1/learn.js',
        IPQS_image: 'https://www.ipqscloud.com/api/stagesurveyflow.pointclub.com/EaNdojhqqL2ByU9s9sIPB5GokoJCqyw2VbGCMFNGzdsGYzuYe4pTEfEsIDKzRr3dk7fZoGjsrNon9QjIE3KTif5rqpkNexeXylZWVSyqO6INYTzodtuGaW9njw4TPGusYjdIEAapl9jqgUr8OqkrXUuk1PdnxMQTheZG3qre3H6bX3XawdGOSAGbiPEqAFFmNFPCw0sLvZKv6vM1wjRsf4qHwsYvDrGDW8EiPs7khGykphuIhujPi3KqIn47qDj1/pixel.png',
        CLEAN_ID_DATA_KEY: 'ECA56E6ED6A1B60942434DD31E11A1AB-30004-1',
        secretKeyToEncDcryPayload: 'innovateStaging',
        chatGPTEnabledJobIds: [236063],
        oldRouteEnable: false,
        supRecnctCodeArr: ['qmeeapi', 'PRMAPI', 'trapi', 'ergapi', 'CPXAPI', 'ICONICAPI', 'GRLAPI', '23201'], // For ComScore tagging
        midTaggingForComscore: true,
        googleAddressVerificationEnabled: true,
        allowedJobIds: ['330448', '330447', '331122', '331121'],
        FINGERPRINT_URL: "https://stagesurveyflow-fing.pointclub.com",
        DFIQ_S2S_API_ENABLED : true,
        VERISOUL_PROJECT_ID: "89f48e44-d45c-4ded-8c57-14a547a01347",
        googleAddressEnableCust: 1990,
        allFingerPrintingJobIds: [335196, 335197],
        veriSoulEnv: 'staging',
        rdUrl : 'https://staging.rtymgt.com/static/js/rd_sys_util.min.js',
        cleanIdIframe : true,
        zipCntShortCodeArr: ['GB', 'CA'],
        srvySatOtherOptId: '5',
        supCodeListForVeritonicPixel: [5228, 5519], // For Veritonic pixel
        VERISOUL_CUSTOM_DOMAIN : 'stage-verfing.pointclub.com',
        VERISOUL_API_TIMEOUT: 10000,
        DFIQ_API_TIMEOUT: 12000,
        ROUNDTABLE_SCRIPT_ID: 'roundtable-rt-js',
        ROUNDTABLE_SCRIPT_SRC: 'https://cdn.roundtable.ai/v1/rt.js',
        ROUNDTABLE_SITE_KEY: 'pub-IFtyTZmsbg5eBXLIJUFn',
        VERISOUL_HK: 'sha256-djmJ48CjCfXomE4x2us2ah26HMfPp94fry65gUtGBSY=',
        VERISOUL_DYNAMIC_SCRIPT_ENABLED: true,
        digitalFingerPrint: {
            'No Fingerprinting': 0,
            'Relevant Id': 1,
            'True Sampling': 2,
            'Research Defender': 3,
            'Clean ID': 4,
            'Verisoul': 5
        }
    },
};
